import { Button } from '@coolblue-development/becky';
import { Compare } from '@coolblue-development/icons';

interface TransferButtonProps {
  onClick: () => void;
}

const TransferButton = ({ onClick }: TransferButtonProps): JSX.Element => {
  return (
    <Button startIcon={<Compare />} onClick={onClick} data-testid="transfer-button" preset="secondary">
      Transfer
    </Button>
  );
};

export default TransferButton;
